/**
 * Default time-range presets shown in the global filter bar.
 *
 * Each preset is a duration in seconds; resolving against `Date.now()`
 * happens in `lib/time.ts` so server queries always get a fresh window.
 */

export interface TimeRangePreset {
  key: TimeRangeKey;
  label: string;
  /** Window length in seconds. */
  seconds: number;
  /** Suggested SQL bucket size (also seconds). */
  bucketSeconds: number;
}

export type TimeRangeKey =
  | "15m"
  | "30m"
  | "1h"
  | "6h"
  | "24h"
  | "7d"
  | "30d"
  | "90d"
  | "custom";

export const TIME_RANGES: readonly TimeRangePreset[] = [
  { key: "15m", label: "Last 15 minutes", seconds: 15 * 60,         bucketSeconds: 30 },
  { key: "30m", label: "Last 30 minutes", seconds: 30 * 60,         bucketSeconds: 60 },
  { key: "1h",  label: "Last 1 hour",     seconds: 60 * 60,         bucketSeconds: 60 },
  { key: "6h",  label: "Last 6 hours",    seconds: 6 * 60 * 60,     bucketSeconds: 5 * 60 },
  { key: "24h", label: "Last 24 hours",   seconds: 24 * 60 * 60,    bucketSeconds: 15 * 60 },
  { key: "7d",  label: "Last 7 days",     seconds: 7 * 86400,       bucketSeconds: 60 * 60 },
  { key: "30d", label: "Last 30 days",    seconds: 30 * 86400,      bucketSeconds: 6 * 60 * 60 },
  { key: "90d", label: "Last 90 days",    seconds: 90 * 86400,      bucketSeconds: 24 * 60 * 60 },
] as const;

export const DEFAULT_TIME_RANGE: TimeRangeKey = "1h";
export const DEFAULT_TIMEZONE = "Pacific/Auckland";
